var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilterInputClearbuttonHover(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "comp-table-filter-input-clearbutton",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1613",
    "data-name": "Rectangle 1613",
    width: 24,
    height: 24,
    fill: "rgba(255,255,255,0)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "close_FILL0_wght400_GRAD0_opsz48",
    d: "M11.273,22.35l-.923-.923,5.077-5.077L10.35,11.273l.923-.923,5.077,5.077,5.077-5.077.923.923L17.273,16.35l5.077,5.077-.923.923L16.35,17.273Z",
    transform: "translate(-4.35 -4.35)",
    fill: "#227c9d"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterInputClearbuttonHover);
export default __webpack_public_path__ + "static/media/Filter-input-clearbutton-hover.09c8d1378a52d1f1c7d694c64fa9609e.svg";
export { ForwardRef as ReactComponent };